import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import GymPassCarousel from './gympass-carousel';

import headerImage from '../../Assets/GymPass/header.png';
import MobilePng from '../../Assets/GymPass/mobile.png';
import IntroPng from '../../Assets/GymPass/laptop.png';
import WaveImage from '../../Assets/GymPass/wave.png';
import GympassNameLogo from '../../Assets/GymPass/gympass-logo.png';

import { ReactComponent as CrossIcon } from '../../Assets/GymPass/cross.svg';
import { ReactComponent as WatchIcon } from '../../Assets/GymPass/watch.svg';
import { ReactComponent as MobileIcon } from '../../Assets/GymPass/mobile.svg';
import { ReactComponent as ShieldIcon } from '../../Assets/GymPass/shield.svg';
import { ReactComponent as ProfileIcon } from '../../Assets/GymPass/profile.svg';
import { ReactComponent as GraphIcon } from '../../Assets/GymPass/graph.svg';
import { ReactComponent as MessageIcon } from '../../Assets/GymPass/message.svg';
import { ReactComponent as Facebook } from '../../Assets/SignUp/Social/facebook.svg';
import { ReactComponent as AssessmentIcon } from '../../Assets/GymPass/assessment.svg';
import { ReactComponent as PlanIcon } from '../../Assets/GymPass/plan.svg';
import { ReactComponent as BookIcon } from '../../Assets/GymPass/book.svg';
import { ReactComponent as Instagram } from '../../Assets/SignUp/Social/instagram.svg';
import { ReactComponent as LinkedIn } from '../../Assets/SignUp/Social/link.svg';
import GymPassLogo from '../../Assets/GymPass/gympass-logo-dark.png';
import { ReactComponent as CheckIcon } from '../../Assets/GymPass/check.svg';
import { useTranslation } from 'react-i18next';
import { Logo } from '../Signup/index';
import DownloadButton from './DownloadButton';

const NixyDownload = () => {
  const { t } = useTranslation();

  return (
    <GymPassPage>
      <Helmet>
        <title>Gympass</title>
        <meta name="description" content="Download Nixy App" />
      </Helmet>
      <Header>
        <ContentWrapper>
          <HeaderLogos>
            <h1>Nixy</h1>
            <Icon as={CrossIcon} className="cross" />
            <img src={GymPassLogo} alt="gympass" className="logo" width={150} />
          </HeaderLogos>
          <HeaderContent>
            <Left>
              <BigH1>{t('stopCoping')}</BigH1>
              <BigH1 style={{ marginBottom: 20 }}>{t('startLiving')}</BigH1>
              <p>{t('traditionalTherapyMakesYouWait')}</p>
              <p style={{ marginBottom: 60 }}>{t('supportRoomOnlineTherapy')}</p>
              <DownloadButton />
            </Left>
          </HeaderContent>
          <img className="background" src={headerImage} alt="header" />
        </ContentWrapper>
        <img className="wave" src={WaveImage} alt="wave" />
      </Header>
      <Section1 id="section-id-1">
        <ContentWrapper>
          <RLWrapper>
            <Left>
              <SmallH2>{t('helpMessage')}</SmallH2>
              <MidH2 style={{ marginBottom: 20 }}>{t('convenientConfidentialAlwaysOn')}</MidH2>
              <MutedP>{t('gymPassText')}</MutedP>
              <div style={{ marginBottom: 40 }}>
                <p>{t('OfferSupportFor')}</p>
                <div style={{ display: 'flex' }}>
                  <div style={{ width: '50%' }}>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('individuals')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('couples')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('students')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('lgbt')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('depression')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('trauma')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('eatingDisorders')}</span>
                    </CheckItem>
                  </div>
                  <div style={{ width: '50%' }}>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('sleepingAnxiety')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('anger')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('grief')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('addictions')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('selfHarm')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('ocd')}</span>
                    </CheckItem>
                    <CheckItem>
                      <Icon as={CheckIcon} /> <span>{t('panicAttacks')}</span>
                    </CheckItem>
                  </div>
                </div>
              </div>
              <DownloadButton />
            </Left>
            <Right>
              <img style={{ maxWidth: '100%' }} src={IntroPng} alt="Mobile" />
            </Right>
          </RLWrapper>
        </ContentWrapper>
      </Section1>
      <Section2 id="section-id-2">
        <GraphWrapper>
          <ContentWrapper>
            <div style={{ textAlign: 'center' }}>
              <SmallH2 style={{ marginBottom: 10 }}>{t('howSupportRoomWorks')}</SmallH2>
              <MidH2>{t('traditionalTherapyMakesYouWait')}</MidH2>
              <MidH2 style={{ marginBottom: 50 }}>{t('supportRoomWaitingForYou')}</MidH2>
            </div>
            <GraphContainer>
              <GraphItem>
                <GraphSvgImage as={AssessmentIcon}></GraphSvgImage>
                <h2>Assessment</h2>
                <p>Log in through GympPass to access your account</p>
              </GraphItem>
              <GraphItem>
                <GraphSvgImage as={PlanIcon}></GraphSvgImage>
                <h2>Your Plan</h2>
                <p>Answer some simple questions to help us establish how we can help.</p>
              </GraphItem>
              <GraphItem>
                <GraphSvgImage as={BookIcon}></GraphSvgImage>
                <h2>Book an initial assessment</h2>
                <p>Book your initial assessment with your therapist, then enjoy 24-7, anytime support afterwards.</p>
              </GraphItem>
            </GraphContainer>
          </ContentWrapper>
        </GraphWrapper>
      </Section2>
      <Section3 id="section-id-3">
        <BenefitWrapper>
          <Left style={{ textAlign: 'right' }}>
            <img id="mobile-img" style={{ maxWidth: '100%', marginRight: 80 }} src={MobilePng} alt="Mobile" />
          </Left>
          <Right>
            <h2 style={{ marginBottom: 40 }}>{t('benefitsOfSupportRoom')}</h2>
            <div style={{ marginBottom: 40 }}>
              <CheckItem>
                <Icon as={WatchIcon} /> <span>{t('supportWhenYouNeed')}</span>
              </CheckItem>
              <CheckItem>
                <Icon as={MobileIcon} />
                <span>{t('checkItem1')}</span>
              </CheckItem>
              <CheckItem>
                <Icon as={ShieldIcon} /> <span>{t('checkItem2')} </span>
              </CheckItem>
              <CheckItem>
                <Icon as={ProfileIcon} /> <span>{t('checkItem3')}</span>
              </CheckItem>
              <CheckItem>
                <Icon as={GraphIcon} /> <span>{t('checkItem4')}</span>
              </CheckItem>
              <CheckItem>
                <Icon as={MessageIcon} /> <span>{t('ongoingSupport')}</span>
              </CheckItem>
            </div>
            <DownloadButton />
          </Right>
        </BenefitWrapper>
      </Section3>
      <Section4 id="section-id-4">
        <ContentWrapper>
          <h2>NIXY's Virtual Services</h2>
          <MidH2Colored>{t('contentWrapper1')}</MidH2Colored>
          <p style={{ marginTop: 20 }}>{t('contentWrapper2')} </p>
          <GymPassCarousel />
        </ContentWrapper>
      </Section4>
      <Footer>
        <Logo src={GympassNameLogo} />
        <LinksWrapper>
          <a href="/about-us/" target="_blank" rel="noopener noreferrer">
            {t('aboutUs')}
          </a>
          <a href="/faqs/" target="_blank" rel="noopener noreferrer">
            {t('faq')}
          </a>
          <Link to="/terms-and-conditions/">{t('terms')}</Link>
          <Link to="/privacy-policy">{t('privacyPolicy')}</Link>
          {/* <a href="https://supportroom.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer">
            Terms
          </a>
          <a href="https://supportroom.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a> */}
          <a href="/emergency-resources/" target="_blank" rel="noopener noreferrer">
            {t('emergency')}
          </a>
        </LinksWrapper>
        <SocialWrapper>
          <a href="https://www.facebook.com/nixy.support" target="_blank" rel="noopener noreferrer">
            <SocialIcon as={Facebook} />
          </a>
          <a href="https://www.instagram.com/nixysupport" target="_blank" rel="noopener noreferrer">
            <SocialIcon as={Instagram} />
          </a>
          <a href="https://uk.linkedin.com/company/nixysupport" target="_blank" rel="noopener noreferrer">
            <SocialIcon as={LinkedIn} />
          </a>
        </SocialWrapper>
      </Footer>
    </GymPassPage>
  );
};

const GymPassPage = styled.div`
  font-family: Roboto, sans-serif;
  font-style: normal;
  //mix-blend-mode: normal;

  section {
    padding: 80px 0;
  }

  p {
    color: black;
  }

  ${({ isModalOpen }) =>
    isModalOpen &&
    css`
      position: fixed;
      width: 100%;
    `}

  @media screen and (max-width: 600px) {
    section {
      padding: 30px 0;
    }
  }
`;

const Icon = styled.svg``;

const SwitchWrapper = styled.div`
  color: white;
  font-size: 16px;
  text-align: right;
`;

const Header = styled.div`
  width: 100%;
  height: 750px;
  position: relative;

  img.background {
    position: absolute;
    bottom: 0;
    right: 0;
    max-height: 95%;
  }

  img.wave {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  background-color: #cbeaf1;

  ${Logo} {
    width: 200px;
  }

  @media screen and (max-width: 500px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px 15px;
    height: 400px;

    img.background,
    img.wave {
      display: none;
    }

    ${Logo} {
      display: block;
      width: 170px;
      margin: 0 0 3px 0;
    }

    ${SwitchWrapper} {
      display: flex;
      div {
        &:last-child {
          margin-left: 5px;
        }
      }
    }
  }

  @media screen and (max-width: 435px) {
    height: 450px;
  }

  @media screen and (max-width: 435px) {
    ${Logo} {
      width: 150px;
    }
  }

  @media screen and (max-width: 340px) {
    ${Logo} {
      width: 140px;
    }
  }
`;

const HeaderLogos = styled.div`
  display: flex;
  align-items: center;
  margin-top: 85px;

  h1 {
    font-size: 24px;
    font-weight: normal;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  ${Icon}.cross {
    color: #6abccc;
    margin-left: 1em;
    margin-right: 1em;
  }

  ${Icon}.logo {
    width: 130px;
  }

  @media screen and (max-width: 500px) {
    margin-top: 15px;
    display: flex;
    ${Icon} {
      width: 110px;
    }

    h1 {
      font-size: 24px !important;
      font-weight: normal;
      text-transform: uppercase;
      margin-bottom: 0;
    }
  }
`;

const SmallH2 = styled.h2`
  color: #6abccc;
`;

const MutedP = styled.p`
  color: #6f6f6f !important;
`;

const BigH1 = styled.h1`
  font-size: 64px;
  line-height: 77.5px;
  font-weight: 700;
  margin: 0;

  @media screen and (max-width: 500px) {
    font-size: 48px;
    line-height: 50px;
  }
`;

const BigH2 = styled.h2`
  font-size: 48px;
  line-height: 48px;
  font-weight: 900;
  margin: 0;
`;

const MidH2 = styled.h2`
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  margin: 0;
`;

const MidH2Colored = styled.h2`
  color: #6abccc;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  margin: 0;
`;

const CheckItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  svg {
    margin-right: 10px;
    width: 22px;
    path {
      fill: #6abccc;
    }
  }
  span {
    color: black;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  margin-top: 60px;
  align-items: center;

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    margin: 0;
  }
`;

const Left = styled.div`
  width: 50%;
  min-width: 435px;
`;

const Right = styled.div`
  width: 50%;
  min-width: 435px;
`;

const BenefitWrapper = styled.div`
  display: flex;

  @media screen and (max-width: 600px) {
    display: block;

    ${Left} {
      display: block;
    }

    ${Right} {
      width: 100% !important;
      display: block;
      min-width: auto;
    }
  }
`;

const GraphWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: rgba(0, 200, 160, 0.05);
  padding: 80px 0;

  @media screen and (max-width: 600px) {
    padding: 40px 0;
  }
`;

const GraphItem = styled.div`
  text-align: center;
  width: 33.33;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 25px;
`;

const GraphContainer = styled.div`
  display: flex;

  @media screen and (max-width: 600px) {
    display: block;

    ${GraphItem} {
      width: 100%;
    }
  }
`;

const GraphSvgImage = styled.svg`
  width: 100%;
`;

const Section1 = styled.section`
  padding-bottom: 0 !important;
  @media screen and (max-width: 950px) {
    ${Right} {
      width: 30%;
      min-width: auto;
    }
    ${Left} {
      width: 70%;
    }
  }
  @media screen and (max-width: 682px) {
    ${Right} {
      display: block;
      width: 100%;
    }
    ${Left} {
      width: 100%;
    }
  }
`;
const Section2 = styled.section`
  padding-bottom: 0 !important;

  @media screen and (max-width: 600px) {
  }
`;

const Section3 = styled.section`
  padding-top: 0;

  @media screen and (max-width: 800px) {
    ${Right} {
      width: 65%;
      padding-left: 20px;
      padding-right: 20px;
    }
    ${Left} {
      width: 45%;
      text-align: center !important;
      min-width: auto;
      img {
        width: 80%;
        margin-right: 0 !important;
        margin-bottom: 20px;
      }
    }
  }
  @media screen and (max-width: 600px) {
    ${Left} {
      display: block;
      margin-right: 0;
      width: 100%;
    }
  }
`;
const Section4 = styled.section`
  background: rgba(0, 200, 160, 0.05);
`;

const RLWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ContentWrapper = styled.div`
  max-width: 1110px;
  margin: 0 auto;

  overflow: hidden;

  padding: 0 30px;

  @media screen and (max-width: 500px) {
    padding: 20px;

    ${HeaderContent} {
      margin-top: 40px;
    }

    ${BigH2} {
      font-size: 34px;
      line-height: 34px;
    }

    ${MidH2} {
      font-size: 28px;
      line-height: 28px;
    }

    h2 {
      font-size: 20px;
    }

    p {
      font-size: 16px;
      line-height: 20px;
    }

    ${Left} {
      width: 100%;
      min-width: auto;
    }
  }
`;

const LinksWrapper = styled.div`
  a {
    font-size: 12px;
    color: white;
    text-decoration: none;
    margin-right: 20px;
    opacity: 0.8;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      opacity: 1;
    }
  }
`;

const SocialIcon = styled.svg`
  opacity: 0.5;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

const SocialWrapper = styled.div`
  ${SocialIcon} {
    margin-right: 15px;
    height: 16px;
  }
`;

const Footer = styled.div`
  width: 100%;
  height: 85px;
  background: #1e1e1e;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 32px;

  ${Logo} {
    width: 165px;
  }

  @media screen and (max-width: 720px) {
    height: 100%;
    padding: 10px 32px;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    ${Logo} {
      width: 130px;
      margin: 0;
      display: block;
    }

    ${LinksWrapper} {
      width: 100%;
      display: flex;
      justify-content: center;

      a {
        margin-right: 20px;
      }
    }

    ${LinksWrapper} {
      margin-bottom: 20px;
    }
  }

  @media screen and (max-width: 420px) {
    ${LinksWrapper} {
      a {
        margin-right: 10px;
      }
    }
  }

  @media screen and (max-width: 370px) {
    ${LinksWrapper} {
      a {
        margin-right: 3px;
      }
    }
  }
`;

export default memo(NixyDownload);
